export const COLOR_T = { it: { tab: "Colora" }, en: { tab: "Coloring" }, es: { tab: "Colorea" }, pt: { tab: "Pinte" } };
